import React, { Component } from 'react';
import { Button, Popconfirm, Modal, Tabs, Icon, Popover, Input, message, Spin, Switch, Radio, Tooltip } from 'antd';
import { Prompt } from 'react-router-dom';
import TableC from '../../basicElement/TableC';
import CloneVisit from './components/CloneVisit';
import CutOff from './components/CutOff';
import PreviewVisit from './components/PreviewVisit';
import SetAgainst from './components/SetAgainst';
import RelatedVisit from './components/RelatedVisit';
import SetCount from './components/SetCount';
import SortList from './components/SortList';
import Update from './components/Update';
import VisitStage from './components/VisitStage';
import PlanVisitParams from './components/PlanVisitParams';
import ExportModal from './components/ExportModal';
import $ from '../../../common/AjaxRequest';
import ExportUtil from '../../../common/ExportUtil';
import ExecuteSider from '../../execute/ExecuteSider';
import ExecuteMgrSider from '../ExecuteMgrSider';
import API_URL from '../../../common/url';
import { ConfigDesc } from './constants';
import { getMatchOption } from '../../shared/selectFn';
import Text from '../../basicElement/Text';
import ConversionParams from './components/ConversionParams';
import InvFileCatalog from './components/InvFileCatalog';

const { TabPane } = Tabs;
const RadioGroup = Radio.Group;

// 访视备注：默认最多显示两行，超出部分省略号显示，鼠标悬停展示全部内容
class CommentText extends Component {
    state = {
        overflow: false, // 内容是否超出两行
    };
    handleMouseEnter = e => {
        const el = e.currentTarget;
        this.setState({ overflow: el.scrollHeight > el.clientHeight });
    };
    handleMouseLeave = () => {
        this.setState({ overflow: false });
    };
    render() {
        const { text } = this.props;
        const { overflow } = this.state;
        return (
            <Tooltip visible={overflow} placement="top" title={text} overlayStyle={{ maxWidth: 300, wordBreak: 'break-all' }}>
                <div
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
                    style={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        wordBreak: 'break-all',
                    }}
                >
                    {text}
                </div>
            </Tooltip>
        );
    }
}


class visitPeriodPlan extends Component {
    constructor(props) {
        super(props);
        const { invState, invStatus, blindInvId, blindType } = sessionStorage;
        this.isConfig = invState == 3;
        this.isNewVisit = false;
        this.published = false;
        this.Audited = false;
        this.completed = invStatus == 'COMPLETED';
        this.isUnBlind = blindType === 'NOTBLIND';
        this.isBoundBlind = !!blindInvId;            // 非盲项目是否绑定盲态项目
        this.state = {
            loading: false,
            panes: [],
            data: [],
            activeKey: '',
            selectKey: '',
            planName: '',
            lineOfBusiness: '',
            invPlanStatus: '',
            isFilterProcess: 1,
            isPublishConfirm: false,
            jumpOtherPage: false,
            approvalHandleShow: false,
            theReasonForRefusal: null,
            approvalStatus: null,
            currentPublishStatus: '',
            designModal: false,
            publishCheckUrl: null,
            investigationFileName: [],
            investigationFileId: [],
            invCreateTimeVisit: '',
            invCreateTime: '',
            medicationList: [], // 用药信息列表（当前访视方案关联了评估访视方案时展示）
        };
        // 访视方案拖拽排序状态
        this.dragState = {
            enabled: false,
            sourceIndex: -1,
            originalPanes: [],
        };
    }

    componentDidMount() {
        this.queryPlan();
        this.queryInvCreateTimeVisit();
    }

    componentDidUpdate() {
        const { panes } = this.state;
        // 方案拖拽排序：不再限制新创建项目，历史项目也可排序
        const shouldEnable = panes.length > 1;
        if (shouldEnable && !this.dragState.enabled) {
            this.enableTabDrag();
        } else if (!shouldEnable && this.dragState.enabled) {
            this.disableTabDrag();
        }
    }

    componentWillUnmount() {
        this.disableTabDrag();
    }

    enableTabDrag = () => {
        this.dragState.enabled = true;
        const tabBar = document.querySelector('.ant-tabs-bar');
        if (!tabBar) return;
        // 给真实访视方案标签设置 draggable
        const { panes } = this.state;
        const allTabs = document.querySelectorAll('.ant-tabs-tab');
        const paneCount = panes.length;
        allTabs.forEach((tab, i) => {
            if (i < paneCount) {
                tab.draggable = true;
            }
        });
        tabBar.addEventListener('dragstart', this.handleTabDragStart);
        tabBar.addEventListener('dragover', this.handleTabDragOver);
        tabBar.addEventListener('drop', this.handleTabDrop);
        tabBar.addEventListener('dragend', this.handleTabDragEnd);
    }

    disableTabDrag = () => {
        this.dragState.enabled = false;
        this.dragState.sourceIndex = -1;
        this.dragState.originalPanes = [];
        const tabBar = document.querySelector('.ant-tabs-bar');
        if (!tabBar) return;
        tabBar.removeEventListener('dragstart', this.handleTabDragStart);
        tabBar.removeEventListener('dragover', this.handleTabDragOver);
        tabBar.removeEventListener('drop', this.handleTabDrop);
        tabBar.removeEventListener('dragend', this.handleTabDragEnd);
        document.querySelectorAll('.ant-tabs-tab').forEach(tab => {
            tab.draggable = false;
            tab.removeAttribute('draggable');
        });
    }

    getAllTabs = () => {
        const { panes } = this.state;
        const allTabs = Array.from(document.querySelectorAll('.ant-tabs-tab'));
        // 只有前 panes.length 个 tab 是真实访视方案（最后一个可能是加号按钮）
        return allTabs.slice(0, panes.length);
    }

    handleTabDragStart = (e) => {
        const tab = e.target.closest('.ant-tabs-tab');
        if (!tab) return;
        if (tab.classList.contains('ant-tabs-tab-disabled')) return;

        const tabs = this.getAllTabs();
        const idx = tabs.indexOf(tab);
        if (idx === -1) return;

        this.dragState.sourceIndex = idx;
        this.dragState.originalPanes = [...this.state.panes];
        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', String(idx));
        tab.style.opacity = '0.5';
    }

    handleTabDragOver = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
    }

    handleTabDrop = (e) => {
        e.preventDefault();
        const sourceIdx = this.dragState.sourceIndex;
        if (sourceIdx === -1) return;

        const tab = e.target.closest('.ant-tabs-tab');
        if (!tab) return;

        const tabs = this.getAllTabs();
        const targetIdx = tabs.indexOf(tab);
        if (targetIdx === -1 || sourceIdx === targetIdx) return;

        const { panes } = this.state;
        const newPanes = [...panes];
        const [moved] = newPanes.splice(sourceIdx, 1);
        newPanes.splice(targetIdx, 0, moved);

        // 判断顺序是否发生变化（基于 item 字段）
        const originalOrder = this.dragState.originalPanes.map(p => p.item);
        const newOrder = newPanes.map(p => p.item);
        const changed = originalOrder.some((val, i) => val !== newOrder[i]);

        if (changed) {
            this.sortVisitGrouping(newPanes);
        } else {
            // 位置未变化，仅更新 panes
            this.setState({ panes: newPanes });
        }

        this.dragState.sourceIndex = -1;
        this.dragState.originalPanes = [];
    }

    handleTabDragEnd = (e) => {
        const tab = e.target.closest('.ant-tabs-tab');
        if (tab) {
            tab.style.opacity = '';
        }
        this.dragState.sourceIndex = -1;
        this.dragState.originalPanes = [];
    }

    sortVisitGrouping = (newPanes) => {
        this.setState({ loading: true });
        const params = {};
        newPanes.forEach((pane, index) => {
            params[`sortGroup[${index}].visitGroupingId`] = pane.visitGroupingId;
            params[`sortGroup[${index}].item`] = index + 1;
        });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.sortVisitGrouping,
            data: {
                ...params,
                investigationId: sessionStorage.invId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success || '排序成功');
                this.setState({ loading: false, panes: newPanes }, () => {
                    this.queryPlan();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });
    }

    queryPlan = () => {
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.queryVisitGrouping,
            data: { publishStatus: this.isConfig ? 'ALL' : '' },
            dataType: 'json',
            doneResult: res => {
                const { activeKey } = this.state;
                const { data, currentPublishStatus, lineOfBusiness, canAudit, publishCheckUrl, investigationFileInfo } = res;
                let nextActiveKey;
                if (activeKey && (data || []).find(i => i.visitGroupingId == activeKey)) {
                    nextActiveKey = activeKey;
                } else {
                    const [{ visitGroupingId } = {}] = data || [];
                    nextActiveKey = visitGroupingId ? String(visitGroupingId) : undefined;
                }
                this.published = currentPublishStatus === 'PUBLISHED';
                this.Audited = (canAudit && currentPublishStatus === 'PENDING_APPROVAL');
                
                const list = investigationFileInfo ? [investigationFileInfo] : []
                const investigationFileName = this.findNodePath(list, 'fileName');
                const investigationFileId = this.findNodePath(list, 'fileManageId');
                this.setState({
                    loading: false,
                    panes: data || [],
                    activeKey: nextActiveKey,
                    lineOfBusiness,
                    currentPublishStatus,
                    publishCheckUrl,
                    investigationFileName,
                    investigationFileId,
                }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });
    }

    queryInvCreateTimeVisit = () => {
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.getInvCreateTimeVisit,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    invCreateTimeVisit: res.invCreateTimeVisit || '',
                    invCreateTime: res.invCreateTime || '',
                });
            },
            errorResult: () => {
                // 静默失败，不影响主流程
            },
        });
    }

    // 递归查找节点路径
    findNodePath = (data, key, path = []) => {
        for (let node of data) {
            const currentPath = [...path, node[key]];
            if (!node.child) {
                return currentPath;
            }
            // 如果有子节点，递归查找
            if (node.child && node.child.length > 0) {
                const foundPath = this.findNodePath(node.child, key, currentPath);
                if (foundPath) {
                    return foundPath;
                }
            }
        }
        return null
    };

    deletePlan = targetKey => {
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.deleteVisitGrouping,
            data: { visitGroupingId: targetKey },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.queryPlan();
                });
            },
            errorResult: (() => {
                this.setState({ loading: false });
            }),
        });
    }

    loadData = () => {
        const { activeKey } = this.state;
        this.loadMedicationInfo();
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.visitTypeDataList,
            data: {
                visitGroupingId: activeKey,
                publishStatus: this.isConfig ? 'ALL' : '',
            },
            dataType: 'json',
            doneResult: res => {
                const { visitTypeList } = res.data || {};
                this.isNewVisit = (visitTypeList || []).length ? visitTypeList[0].count != undefined : true;
                this.setState({
                    loading: false,
                    data: visitTypeList || [],
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });
    }

    // 用药信息查询：当前访视方案关联了评估访视方案（evaluateVisitGroupingId 有值且大于 0）时查询
    loadMedicationInfo = () => {
        // CRC 不可见用药信息，无需查询
        if (sessionStorage.curRole === 'CRC') {
            this.setState({ medicationList: [] });
            return;
        }
        const { panes, activeKey } = this.state;
        const activePane = (panes || []).find(pane => pane.visitGroupingId == activeKey) || {};
        const { evaluateVisitGroupingId } = activePane;
        if (evaluateVisitGroupingId && evaluateVisitGroupingId > 0) {
            $.sendRequest({
                method: 'POST',
                url: API_URL.evaluate.queryVisitGroupingMedicationInfo,
                data: {
                    evaluateVisitGroupingId,
                },
                dataType: 'json',
                doneResult: res => {
                    const { medicationInfo } = res.data || {};
                    this.setState({
                        medicationList: this.formatMedicationList(medicationInfo),
                    });
                },
                errorResult: () => {
                    this.setState({ medicationList: [] });
                },
            });
        } else {
            this.setState({ medicationList: [] });
        }
    }

    // 用药信息列表数据转换（参考临床评估 ForecastParams 访视方案列表：按给药途径展开行，随机病例数/药物数量合并单元格）
    formatMedicationList = medicationInfo => {
        if (!medicationInfo) {
            return [];
        }
        const { routeList = [], cycleShow, hospitalMedicationFrequencyShow, treatmentPeriodFrequencyShow } = medicationInfo;
        const list = [];
        if ((routeList || []).length) {
            routeList.forEach((route, routeIndex) => {
                const { evaluateHospitalMedicationFrequencyOptimize } = route;
                const hasOptimize = evaluateHospitalMedicationFrequencyOptimize
                    && typeof evaluateHospitalMedicationFrequencyOptimize === 'object'
                    && Object.keys(evaluateHospitalMedicationFrequencyOptimize).length > 0;
                list.push({
                    ...medicationInfo,
                    ...route,
                    ...(hasOptimize ? evaluateHospitalMedicationFrequencyOptimize : {
                        visitCycleShow: cycleShow,
                        medicationCycleShow: hospitalMedicationFrequencyShow,
                        medicationShow: treatmentPeriodFrequencyShow,
                    }),
                    rowSpan: routeIndex === 0 ? routeList.length : 0,
                    rowId: `${medicationInfo.evaluateRecordCalculateTreatGroupId || 'group'}-${route.evaluateRecordCalculateRouteId || routeIndex}`,
                });
            });
        } else {
            list.push({
                ...medicationInfo,
                rowSpan: 1,
                rowId: `${medicationInfo.evaluateRecordCalculateTreatGroupId || 'group'}`,
            });
        }
        return list;
    }

    getMedicationColumns = () => ([
        {
            title: '随机病例数',
            dataIndex: 'randomCaseNum',
            key: 'randomCaseNum',
            width: 100,
            render: (value, row) => {
                const obj = {
                    children: value,
                    props: {},
                };
                if (row.rowSpan != null) {
                    obj.props.rowSpan = row.rowSpan;
                }
                return obj;
            },
        }, {
            title: '药物数量',
            dataIndex: 'medicationNumberName',
            key: 'medicationNumberName',
            width: 100,
            render: (value, row) => {
                const obj = {
                    children: value,
                    props: {},
                };
                if (row.rowSpan != null) {
                    obj.props.rowSpan = row.rowSpan;
                }
                return obj;
            },
        }, {
            title: '给药途径',
            dataIndex: 'routeName',
            key: 'routeName',
            width: 100,
        }, {
            title: '给药类别',
            dataIndex: 'routeType',
            key: 'routeType',
            width: 100,
        }, {
            title: '药物名称',
            dataIndex: 'drugName',
            key: 'drugName',
            width: 120,
        }, {
            title: '来院访视周期',
            dataIndex: 'visitCycleShow',
            key: 'visitCycleShow',
            width: 120,
        }, {
            title: '来院用药频率（指的是患者来院访视用药）',
            dataIndex: 'medicationCycleShow',
            key: 'medicationCycleShow',
            width: 160,
        }, {
            title: '治疗期来院用药次数',
            dataIndex: 'medicationShow',
            key: 'medicationShow',
            width: 130,
        },
    ])

    toExport = () => {
        const { invId } = sessionStorage;
        const { activeKey } = this.state;
        ExportUtil.export({ investigationId: invId, visitGroupingId: activeKey }, null, API_URL.export.exportVisitType);
    }

    export = () => {
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.queryInvLineOfBusiness,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { data } = res || {};
                if (data == '39' || data == '40') { // 39 = ARO; 40 = 招募;  后台提供
                    this.toExport();
                } else {
                    const { invId } = sessionStorage;
                    const { activeKey, invPlanStatus } = this.state;
                    this.exportModalRef.show({ investigationId: invId, visitGroupingId: activeKey, invPlanStatus });
                }
            },
            errorResult: () => {
                // this.setState({ loading: false });
            },
        });
    }

    getInvPlanStatus = paramms => {
        const { data: invPlanStatus, isFilterProcess } = paramms || {};
        this.setState({
            invPlanStatus,
            isFilterProcess,
        });
    }

    preDelete = (visitTypeId, /* 检验位 */ confirm, confirmManHour) => {
        // 删除校验已从 deleteVisitType 接口拆分至 judgeCanDelVisitType，首次删除前需先调用校验
        if (!confirm && !confirmManHour) {
            this.judgeCanDelVisitType(visitTypeId);
            return;
        }
        this.deleteVisitType(visitTypeId, confirm, confirmManHour);
    }

    // 删除前校验：不可删除时接口直接报错提示；可删除但需二次确认时返回 confirmError/confirmManHourError
    judgeCanDelVisitType = visitTypeId => {
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.judgeCanDelVisitType,
            data: {
                visitTypeId,
            },
            dataType: 'json',
            doneResult: res => {
                const { confirmError, confirmManHourError } = res;
                this.setState({ loading: false });
                if (confirmError) {
                    this.confirmDelete(visitTypeId, confirmError, 'confirm', confirmManHourError);
                } else if (confirmManHourError) {
                    this.confirmDelete(visitTypeId, confirmManHourError, 'manHour');
                } else {
                    this.deleteVisitType(visitTypeId, 0, 0);
                }
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });
    }

    deleteVisitType = (visitTypeId, confirm, confirmManHour) => {
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.deleteVisitType,
            data: {
                visitTypeId,
                confirm,
                confirmManHour,
            },
            dataType: 'json',
            doneResult: res => {
                const { confirmError, confirmManHourError } = res;
                this.setState({ loading: false });
                if (confirmError) {
                    this.confirmDelete(visitTypeId, confirmError, 'confirm', confirmManHourError);
                } else if (confirmManHourError) {
                    this.confirmDelete(visitTypeId, confirmManHourError, 'manHour');
                } else {
                    message.success('删除成功！');
                    this.loadData();
                }
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });
    }

    confirmDelete = (visitTypeId, message, type, pendingManHourError) => {
        Modal.confirm({
            iconType: 'exclamation-circle',
            title: <div style={{ marginLeft: 42 }}>{message}</div>,
            onOk: () => {
                if (type == 'confirm') {
                    // 校验接口可能同时返回 confirmError 和 confirmManHourError，需依次确认后再删除
                    if (pendingManHourError) {
                        this.confirmDelete(visitTypeId, pendingManHourError, 'manHour');
                    } else {
                        this.preDelete(visitTypeId, 1, 0);
                    }
                } else if (type == 'manHour') {
                    this.preDelete(visitTypeId, 1, 1);
                }
            },
        });
    }

    prePublish = () => {
        const { currentPublishStatus } = this.state;
        if (currentPublishStatus === 'PENDING_APPROVAL') {
            message.error('访视周期计划发布审批中，不可重复发布！');
        } else {
            Modal.confirm({
                iconType: 'question-circle',
                title: this.published ? '是否取消发布访视周期计划' : '是否确认发布已配置的访视周期计划',
                content: this.published ? '取消发布后，访视记录填写页不再显示访视周期计划部分（取消发布不会影响已填写的数据）' : '待领域leader/业务线负责人审批通过后会自动发布',
                onOk: this.publish,
            });
        }
    }

    designModal = () => {
        // this.setState({ designModal: true });
        this.InvFileCatalogRef.show();
    }

    designModalOk = () => {
        const { publishCheckUrl } = this.state;
        if (publishCheckUrl) {
            this.setState({ designModal: false });
            $.sendRequest({
                method: 'POST',
                url: API_URL.plan.savePublishUrl,
                data: {
                    publishCheckUrl,
                },
                dataType: 'json',
                doneResult: res => {
                    this.prePublish();
                },
                errorResult: () => {
                    this.setState({ loading: false });
                },
            });
        } else {
            message.warning('请输入设计方案超链接！');
        }
    }

    publish = () => {
        const { invId } = sessionStorage;
        const { jumpOtherPage, approvalStatus, theReasonForRefusal } = this.state;
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.updateVisitTypePublishStatus,
            data: {
                investigationId: invId,
                publishStatus: approvalStatus?approvalStatus:this.published ? 'UNPUBLISHED' : 'PUBLISHED',
                remark: theReasonForRefusal,
            },
            dataType: 'json',
            doneResult: () => {
                message.success(`${approvalStatus ? '审批' : this.published ? '取消' : '发布'}成功`);
                this.setState({ loading: false, approvalHandleShow: false }, () => {
                    this.queryPlan();
                    if (jumpOtherPage) {
                        window.location.reload();
                        this.cancelConfirm();
                    }
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });
    }

    getColumns = () => {
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 60,
        }, {
            title: '访视阶段',
            dataIndex: 'stageValue',
            key: 'stageValue',
            fixed: 'left',
            width: 160,
            render: (value, row, index) => {
                const obj = {
                    children: value,
                    props: {},
                };
                if (row.rowSpan != null) {
                    obj.props.rowSpan = row.rowSpan;
                }
                return obj;
            },
        }, {
            title: '访视周期',
            dataIndex: 'periodValue',
            key: 'periodValue',
            width: 100,
            render: (value, row, index) => {
                const obj = {
                    children: value,
                    props: {},
                };
                if (row.periodRowSpan != null) {
                    obj.props.rowSpan = row.periodRowSpan;
                }
                return obj;
            },
        }];
        // 访视类别、访视备注 各视图（配置项目/中心汇总/具体中心）下均展示
        columns.push({
            title: '访视类别',
            dataIndex: 'visitCategory',
            key: 'visitCategory',
            width: 100,
        }, {
            // 访视类型调整到访视类别后面
            title: '访视类型',
            dataIndex: 'visitingTypeShow',
            key: 'visitingTypeShow',
            width: 160,
        });
        columns.push({
            title: '访视次数',
            dataIndex: 'visitTypeName',
            key: 'visitTypeName',
            width: 100,
        });
        if (this.isBoundBlind) {
            columns.push({
                title: '关联对应盲态项目访视次数',
                dataIndex: 'relatedTypeName',
                key: 'relatedTypeName',
                width: 100,
            });
        }
        if (sessionStorage.curRole !== 'CRC') {
            columns.push({
                title:(
                    <span>
                        单访视工时
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'点击下方图标，可查看合同计划单访视工时折算系数'}>
                            <a 
                                onClick={() => this.conversionParamsRef.show()}
                            >
                                <Icon style={{ marginLeft: 6, fontSize: '14px' }} type="info-circle-o" />
                            </a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'singleVisitHour',
                key: 'singleVisitHour',
                width: 120,
            })
        }
        
        columns.push(
        {
            title: '次数',
            dataIndex: 'count',
            key: 'count',
            width: 80,
        });
        // 访视备注调整到次数后面
        columns.push({
            title: '访视备注',
            dataIndex: 'visitComment',
            key: 'visitComment',
            width: 150,
            render: text => <CommentText text={text} />,
        });
        columns.push({
            title: '对照基准',
            dataIndex: 'referenceVisitTypeName',
            key: 'referenceVisitTypeName',
            width: 100,
        }, {
            title: '访视时间点',
            dataIndex: 'visitTypeWindowDay',
            key: 'visitTypeWindowDay',
            width: 100,
        }, {
            title: '访视窗口',
            dataIndex: 'visitTypeWindowInfo',
            key: 'visitTypeWindowInfo',
            width: 100,
        });
        if (this.isConfig) {
            const disabled = this.completed || !this.isNewVisit;
            columns.push({
                title: '操作',
                key: 'operation',
                fixed: 'right',
                width: 200,
                render: (text, record) => {
                    const { visitTypeId } = record;
                    return (
                        <span>
                            <a disabled={disabled || this.published} onClick={() => this.update(record, 'edit')}>修改</a>
                            <span className="ant-divider" />
                            <Popconfirm
                                title="确定要删除吗?"
                                onConfirm={() => this.preDelete(visitTypeId, 0, 0)}
                                okText="确定"
                                cancelText="取消"
                            >
                                <a disabled={disabled || this.published}>删除</a>
                            </Popconfirm>
                            <span className="ant-divider" />
                            <a disabled={disabled} onClick={() => this.setCount(record)}>设置次数</a>
                            <span className="ant-divider" />
                            <a disabled={disabled} onClick={() => this.setAgainst(record)}>设置违背</a>
                            <span className="ant-divider" />
                            <a disabled={disabled || this.published} onClick={() => this.setRelated(record)}>关联访视次数</a>
                        </span>
                    );
                },
            });
        }
        return columns;
    }

    handleTabChange = activeKey => {
        if (activeKey != 'plus-circle-o') {
            this.setState({ activeKey }, () => {
                this.loadData();
            });
        }
    }

    handleTabAction = (targetKey, action) => {
        if (action === 'add') {
            this.cloneRef.show();
        } else if (action === 'remove') {
            Modal.confirm({
                iconType: 'exclamation-circle',
                title: '确定要删除该访视方案吗?',
                onOk: () => {
                    this.deletePlan(targetKey);
                },
            });
        }
    }

    handleDbClick = ({ visitGroupingId, visitGroupingName }) => {
        this.setState({
            selectKey: visitGroupingId,
            planName: visitGroupingName,
        }, () => {
            document.getElementById(visitGroupingId).focus();
        });
    }

    handleChange = e => {
        this.setState({ planName: e.target.value });
    }

    handleBlur = () => {
        const { planName, selectKey } = this.state;
        if (!planName || !planName.trim()) {
            return message.warning('访视方案名称不能为空!');
        }
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.modifyVisitGrouping,
            data: {
                visitGroupingId: selectKey,
                visitGroupingName: planName,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    selectKey: '',
                    planName: '',
                }, () => {
                    this.queryPlan();
                });
            },
        });
    }

    sort = () => {
        this.sortRef.show();
    }

    addStage = () => {
        this.stageRef.show();
    }

    planVisitParams = () => {
        this.planVisitParamsRef.show();
    }

    update = (record, type) => {
        this.updateRef.show(record, type);
    }

    setCount = record => {
        if (record.relatedId) {
            message.error('本访视与盲态项目已关联，不可单独设置次数！');
        } else {
            this.countRef.show(record);
        }
    }

    setAgainst = record => {
        this.againstRef.show(record);
    }

    setRelated = record => {
        const { invCreateTime, invCreateTimeVisit } = this.state;
        if (invCreateTime && invCreateTimeVisit && invCreateTime < invCreateTimeVisit) {
            message.warning(`只有${invCreateTimeVisit}后新创建的项目才可关联访视`);
            return;
        }
        this.relatedRef.show(record);
    }

    cutOff = () => {
        this.cutOffRef.show();
    }

    preview = () => {
        this.previewRef.show();
    }

    getContent = ({ visitGroupingId, evaluateVisitGroupingId }) => {
        const { data, activeKey, medicationList } = this.state;
        if (visitGroupingId == activeKey) {
            const disabled = this.completed || !this.isNewVisit;
            // evaluateVisitGroupingId 有值且大于 0 时显示用药信息（CRC 不可见）
            const showMedication = sessionStorage.curRole !== 'CRC' && !!evaluateVisitGroupingId && evaluateVisitGroupingId > 0;
            return (
                <div>
                    {
                        this.isConfig &&
                        <div className="filter-bar tar">
                            <Button disabled={disabled} type="primary" onClick={this.addStage}>添加阶段/周期</Button>
                            <Button disabled={disabled || this.published} type="primary" onClick={() => this.update({}, 'add')}>添加访视</Button>
                            <Button disabled={disabled} type="primary" onClick={this.sort}>排序调整</Button>
                            {
                                !this.isNewVisit &&
                                <Button style={{ position: 'absolute', right: 0, color: '#fff', background: '#f04134' }} onClick={this.cutOff}>访视次数割接调整</Button>
                            }
                        </div>
                    }
                    {
                        showMedication &&
                        <div style={{ marginTop: 20, marginBottom: 35 }}>
                            <TableC
                                data={medicationList}
                                columns={this.getMedicationColumns()}
                                rowKey="rowId"
                            />
                        </div>
                    }
                    <TableC
                        data={data}
                        columns={this.getColumns()}
                        className="visitPeriodPlan"
                        rowKey="visitTypeId"
                    />
                </div>
            );
        }
        return null;
    }

    toggle = checked => {
        const options = {
            method: 'POST',
            url: API_URL.plan.changeInvestigationFilterProcess,
            data: {
                isFilterProcess: checked ? 1 : 0,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                const isFilterProcess = checked ? 1 : 0;
                this.setState({ isFilterProcess });
            },
        };
        $.sendRequest(options);
    }

    // 跳转页面时，提示信息弹出框
    unAddShelf =location => {
        const { currentPublishStatus } = this.state;
        if (currentPublishStatus === 'UNPUBLISHED') {
            // location 携带的路径
            const pathUrl = location.pathname + location.search;
            this.setState({
                redirectUrl: pathUrl,
                isPublishConfirm: true,
            });
            return false;
        }
    }

    saveSessionStorage = () => {
        const { curSession } = localStorage;
        if (curSession) {
            const backSession = JSON.parse(curSession) || {};
            (Object.keys(backSession) || []).forEach(item => {
                sessionStorage[item] = backSession[item];
            },
            );
        }
    }

    noPublish =() => {
        window.location.reload();
        this.cancelConfirm();
    }

    toPublish =() => {
        this.saveSessionStorage();
        setTimeout(() => {
            this.setState({
                jumpOtherPage: true,
            }, () => {
                this.designModal();
                location.href = './#/executeMgr/visitPeriodPlan';
                this.cancelConfirm();
            });
        }, 10);
    }

    backToEdit =() => {
        this.saveSessionStorage();
        setTimeout(() => {
            location.href = './#/executeMgr/visitPeriodPlan';
            window.location.reload();
            this.cancelConfirm();
        }, 10);
    }

    cancelConfirm =() => {
        localStorage.removeItem('curSession');
        this.setState({
            isPublishConfirm: false,
        });
    }

    audit =() => {
        const { approvalStatus, theReasonForRefusal } = this.state;
        if (!approvalStatus) {
            message.error('请选择审核结论！');
            return;
        } else if (approvalStatus === 'DISAGREE_APPROVAL' && !theReasonForRefusal) {
            message.error('请填写审核不通过原因！');
            return;
        }
        this.publish();
    }

    openNewPage = () => {
        const { investigationFileId } = this.state;
        // 要传递给新页面的数据
        const dataToStore = { 
            invState: 1, 
            investigationSiteName: '中心汇总', 
            investigationFileId 
        };
        
        // 编码为 URL 参数（使用 encodeURIComponent 避免特殊字符问题）
        const queryParams = new URLSearchParams();
        queryParams.append('data', JSON.stringify(dataToStore));
        
        // 打开新页面并传递参数
        window.open(`./#/fileManagement/projectFile?${queryParams.toString()}`, '_blank');
    };
    
    

    render() {
        const { loading, panes, activeKey, selectKey, planName, lineOfBusiness, isFilterProcess, isPublishConfirm, approvalHandleShow, approvalStatus, theReasonForRefusal, designModal, publishCheckUrl, investigationFileName, currentPublishStatus } = this.state;
        const { invState, blindType } = sessionStorage;
        const isUnBlind = blindType === 'NOTBLIND';
        const { relatedId } = getMatchOption(panes, 'visitGroupingId', activeKey);
        const editable = this.isConfig && !this.isBoundBlind && !this.published;
        return (
            <div className="content">
                {
                    this.isConfig ?
                        <ExecuteMgrSider selectKey="visitPeriodPlan" />
                    :
                        <ExecuteSider selectKey="visitPeriodPlan" />
                }
                <div className="main plan-visitType">
                    <div className="breadcrumb-bar tac">
                        {
                            this.isConfig &&
                            <Popover placement="right" overlayClassName="propercent-pop" content={ConfigDesc}>
                                <div style={{ float: 'left' }}>
                                    <Icon type="info-circle" style={{ color: '#5750c9', marginRight: 4 }} />
                                    <a>配置说明</a>
                                </div>
                            </Popover>
                        }
                        <h2 className="title">访视周期计划</h2>
                    </div>
                    <div style={{ margin: '10px 0', textAlign: 'right' }}>
                        {
                            (this.isConfig && !isUnBlind) && <span style={{ marginRight: '10px' }}><Switch checkedChildren="开" unCheckedChildren="关" onChange={this.toggle} checked={isFilterProcess == 1} /> 筛选流程</span>
                        }
                        {lineOfBusiness !== null && lineOfBusiness !== '39' && lineOfBusiness !== '40' && this.isConfig && <Button type="primary" onClick={this.planVisitParams}>计划访视参数设置</Button>}
                        {/* 中心汇总下且未发布时，不显示导出按钮 */}
                        {!(invState == 1 && !this.published) && <Button type="primary" onClick={this.export} style={{ marginLeft: 8 }}>导出</Button>}
                        { this.isConfig && !this.isUnBlind && <Button type="primary" style={{ marginLeft: 8 }} onClick={this.preview}>预览</Button> }
                        { this.isConfig && <Button type="primary" style={{ marginLeft: 8 }} onClick={this.Audited ? () => { this.setState({ approvalHandleShow: true }); } : this.published ? this.prePublish : this.designModal}>{this.Audited ? '发布审批' : this.published ? '取消发布' : '发布' }</Button> }
                    </div>
                    <Spin spinning={loading}>
                        <Tabs
                            hideAdd
                            activeKey={activeKey}
                            type="editable-card"
                            onEdit={this.handleTabAction}
                            onChange={this.handleTabChange}
                        >
                            {
                                panes.map((pane, index, array) => {
                                    const { visitGroupingId, visitGroupingName } = pane;
                                    const closable = editable && (array.length > 1);
                                    let title = visitGroupingName;
                                    if (editable) {
                                        title = <span onDoubleClick={() => this.handleDbClick(pane)}>{visitGroupingName}</span>;
                                    }
                                    if (selectKey === visitGroupingId) {
                                        title = <Input value={planName} id={visitGroupingId} style={{ width: 100 }} onChange={this.handleChange} onBlur={this.handleBlur} />;
                                    }
                                    return (
                                        <TabPane
                                            key={visitGroupingId}
                                            tab={title}
                                            closable={closable}
                                        >
                                            {this.getContent(pane)}
                                        </TabPane>
                                    );
                                })
                            }
                            {
                                editable ?
                                    <TabPane
                                        closable={false}
                                        key="plus-circle-o"
                                        tab={<Icon type="plus-circle-o" onClick={() => this.handleTabAction('', 'add')} />}
                                    />
                                :
                                    []
                            }
                        </Tabs>
                    </Spin>
                    <SetCount ref={el => this.countRef = el} loadData={this.loadData} />
                    <VisitStage ref={el => this.stageRef = el} loadData={this.loadData} visitGroupingId={activeKey} />
                    <PlanVisitParams
                        ref={el => this.planVisitParamsRef = el} loadData={this.loadData}
                        visitGroupingId={activeKey}
                        panes={panes} handleDbClick={this.handleDbClick}
                        getInvPlanStatus={this.getInvPlanStatus}
                    />
                    <SetAgainst ref={el => this.againstRef = el} loadData={this.loadData} visitGroupingId={activeKey} />
                    <RelatedVisit ref={el => this.relatedRef = el} loadData={this.loadData} visitGroupingId={activeKey} />
                    <CutOff ref={el => this.cutOffRef = el} loadData={this.loadData} visitGroupingId={activeKey} />
                    <SortList ref={el => this.sortRef = el} loadData={this.loadData} visitGroupingId={activeKey} />
                    <CloneVisit ref={el => this.cloneRef = el} panes={panes} loadData={this.queryPlan} />
                    <PreviewVisit ref={el => this.previewRef = el} isFilterProcess={isFilterProcess} />
                    <ConversionParams ref={el => this.conversionParamsRef = el}/>
                    <Update
                        ref={el => this.updateRef = el}
                        loadData={this.loadData}
                        visitGroupingId={activeKey}
                        refGroupId={relatedId}
                        isBoundBlind={this.isBoundBlind}
                    />
                    <ExportModal ref={el => this.exportModalRef = el} />
                </div>
                {/* 跳转页面时的确认框 */}
                <Modal
                    // title=""
                    visible={isPublishConfirm}
                    onCancel={this.cancelConfirm}
                    className="create-modal sort-modal"
                    wrapClassName="vertical-center-modal"
                    maskClosable={false}
                    width="500px"
                    footer={[
                        <Button type="primary" onClick={this.backToEdit}>
                            返回修改
                        </Button>,
                        <Button type="primary" onClick={this.noPublish}>
                            否，暂不发布
                        </Button>,
                        <Button type="primary" onClick={this.toPublish}>
                            是，立刻发布
                        </Button>,
                    ]}
                >
                    <div style={{ margin: '25px', fontSize: '16px', fontWeight: 'bloder' }}>
                        <Icon type="question-circle" style={{ fontSize: 24, color: '#ffbf00' }} />
                        <span style={{ marginLeft: 10 }}>您还没有发布访视周期计划，是否立刻发布？</span></div>
                </Modal>

                <Prompt
                    when={!this.published && this.isConfig}
                    message={this.unAddShelf.bind(this)}
                />
                {/* 跳转页面时的确认框 -- 结束*/}
                <Modal
                    title="发布审批"
                    visible={approvalHandleShow}
                    className="creat-modal EditPersonModal"
                    wrapClassName="vertical-center-modal"
                    maskClosable={false}
                    width="400px"
                    closable={false}
                    footer={<div style={{ textAlign: 'center' }}>
                        <Button style={{ margin: '0 5px' }} onClick={() => { this.setState({ approvalHandleShow: false }); }}>取消</Button>
                        <Button style={{ margin: '0 5px', backgroundColor: '#1890ff' }} onClick={this.audit} type="primary">确定</Button>
                    </div>}
                >
                    <div>
                        <div style={{ fontSize: '14px', fontWeight: '700', marginBottom: '5px' }}>PM访视周期计划配置内容确认</div>
                        {/* <p >设计方案超链接：<span style={{ width: '270px', display: 'inline-block', wordBreak: 'break-word', verticalAlign: 'top', whiteSpace: 'pre-wrap' }}>{publishCheckUrl}</span></p> */}
                        <p>
                            设计方案文件路径：
                            <span 
                                style={{ 
                                    width: '270px', 
                                    display: 'inline-block',
                                    wordBreak: 'break-word', 
                                    verticalAlign: 'top', 
                                    whiteSpace: 'pre-wrap',
                                }}
                            >
                                {(investigationFileName || []).join('-')}
                                <a 
                                    style={{ marginLeft: 8 }}
                                    onClick={this.openNewPage}
                                >
                                    跳转
                                </a>
                            </span> 
                        </p>
                        <div >
                            <label className="ui-label visit-lablel" style={{ width: '200px', textAlign: 'right' }}><Text asterisk>审核结论:</Text></label>
                            <RadioGroup onChange={e => { this.setState({ approvalStatus: e.target.value }); }} value={approvalStatus} >
                                <Radio style={{ marginLeft: '20px' }} value={'AGREE_APPROVAL'}>审批通过</Radio>
                                <Radio style={{ margin: '10px' }} value={'DISAGREE_APPROVAL'}>审批不通过</Radio>
                            </RadioGroup>
                        </div>
                        {
                            (approvalStatus == 'DISAGREE_APPROVAL') &&
                            <div style={{ marginTop: '5px' }}>
                                <label className="ui-label visit-lablel" style={{ width: '200px', textAlign: 'right' }}><Text asterisk>审核不通过原因:</Text></label>
                                <Input
                                    placeholder="请输入不通过原因"
                                    value={theReasonForRefusal}
                                    onChange={e => { this.setState({ theReasonForRefusal: e.target.value }); }}
                                    style={{ width: '200px', marginLeft: '20px' }}
                                />
                            </div>
                        }

                    </div>
                </Modal>
                <Modal
                    title="设计方案"
                    visible={designModal}
                    onCancel={() => { this.setState({ designModal: false }); }}
                    className="create-modal sort-modal"
                    wrapClassName="vertical-center-modal"
                    maskClosable={false}
                    width="350px"
                    footer={[
                        <Button onClick={() => { this.setState({ designModal: false }); }}>
                            关闭
                        </Button>,
                        <Button type="primary" onClick={this.designModalOk}>
                            确定
                        </Button>,
                    ]}
                >
                    <div>
                        <span style={{ color: 'red' }}>*</span>设计方案超链接：
                        <Input
                            style={{ width: '200px' }}
                            placeholder="请输入"
                            value={publishCheckUrl}
                            onChange={e => this.setState({ publishCheckUrl: e.target.value })}
                        />
                    </div>
                </Modal>
                <InvFileCatalog 
                    ref={el => this.InvFileCatalogRef = el} 
                    currentPublishStatus={currentPublishStatus}
                    published={this.published}
                    publish={this.publish}
                />
            </div>
        );
    }
}

export default visitPeriodPlan;



// WEBPACK FOOTER //
// ./src/components/executeMgr/visitPeriodPlan/index.js